import * as yup from 'yup';
import { ISelectOption } from '../../../../../ui-toolkit';

export const LenderClientSchema = (
  allLenders: Array<ISelectOption<string>>,
  allClients: Array<ISelectOption<string>>,
  allLenderUsers: Array<ISelectOption<string>>
) => {
  return yup.object().shape({
    clientId: yup
      .string()
      .required()
      .test(
        'clientId',
        'Enter a valid Client',
        (value: string | null | undefined) => !!allClients.find((client) => client.value === value)
      ),
    lenderId: yup
      .string()
      .required()
      .test(
        'lenderId',
        'Enter a valid Lender',
        (value: string | null | undefined) => !!allLenders.find((lender) => lender.value === value)
      ),
    orderContactId: yup
      .string()
      .nullable()
      .test(
        'orderContact',
        'Enter a valid Order Contact',
        (value: string | null | undefined) =>
          value === null || value === undefined || !!allLenderUsers.find((user) => user.value === value)
      ),
  });
};

export interface ILenderClientSchema {
  clientId: string;
  lenderId: string;
  orderContactId: string;
}
